import type { UserProfile } from '@/types/api';

const PLATFORM_ROLES = new Set(['super_admin', 'super_reader']);

/** Return true when the user holds a platform-wide role. */
export function isPlatformRoleUser(user: UserProfile): boolean {
  const roleName = user.role?.name;
  return roleName != null && PLATFORM_ROLES.has(roleName);
}
